export const API_BASE_URL = "https://baila-api.social/";

export const API_DEV_URL = process.env.REACT_APP_API_DEV_URL || "http://127.0.0.1:5000/";

export const CLUBS_URL = API_BASE_URL + "clubs/";

export const EVENT_URL = API_BASE_URL + "events/";
